export const getErrorMessage = (error: number | unknown): string => {
  switch (error) {
    case 413:
      return 'resources.soundfiles.errors.fileTooBig';
    case 404:
      return 'resources.soundfiles.errors.fileNotFound';
    default:
      return 'resources.soundfiles.errors.generic';
  }
};
